<template>
  <div id="app">
    <el-container>
      <el-header>
        <div class="logo">
          <img src="./assets/img/toplogo2.png" alt/>
        </div>
        <el-menu
            :default-active="defaultActive"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
            :router="router"
        >
          <el-menu-item index="/">首页 Home</el-menu-item>
          <el-menu-item index="/products">产品中心 Product Center</el-menu-item>
          <el-menu-item index="/contact">联系我们 Contact us</el-menu-item>
        </el-menu>
      </el-header>
      <el-main>
        <router-view/>
      </el-main>
      <div class="footer" v-show="isShow">
        <div class="footer-content">
          <ul class="content-nav">
            <li>
              <p>联系我们 Contact us</p>
              <span>邮箱 Email：{{ contact.email }}</span>
              <span>电话 Phone：{{ contact.mobile }}</span>
              <span>地址 Address：{{ contact.address }}</span>
            </li>
          </ul>
          <div class="qr-code-container">
            <div>
              <img @click="openPhoto(contact.wxQrcode1)" :src="contact.wxQrcode1" alt/>
              <span>{{ contact.wxQrcode1Title }}</span>
            </div>
            <div>
              <img @click="openPhoto(contact.wxQrcode2)" :src="contact.wxQrcode2" alt/>
              <span>{{ contact.wxQrcode2Title }}</span>
            </div>
          </div>
        </div>
        <div>
          <!-- 大图模态框 -->
          <el-dialog
              :visible.sync="showLargeImage"
              @click="showLargeImage=false">
            <el-image :src="largeImageUrl" fit="fill"/>
          </el-dialog>
        </div>
        <div class="copyright">
          <span>牡丹江双荣木皮版权所有</span>
        </div>
      </div>
    </el-container>
  </div>
</template>

<script>
export default {

  data() {
    return {
      router: true,
      defaultActive: "/",
      isShow: false,
      contact: {},
      showLargeImage: false,
      largeImageUrl: ''
    };
  },
  methods: {
    openPhoto(src) {
      this.showLargeImage = true;
      this.largeImageUrl = src;
    },
    handleSelect(key) {
      this.isShow = this.defaultActive != key;
      window.console.log(this.isShow);
    },
    getContact() {
      this.$http
          .get("officialwebsiteContact/getActive")
          .then(response => {
            this.contact = response.data.result;
            this.loading = false;
          })
          .catch(function (error) {
            window.console.log(error);
          });
    }
  },
  created() {
    this.getContact()
  }
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}

html,
body {
  height: 100%;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.el-header {
  display: flex;
  justify-content: space-between;
  align-content: center;
  width: 100%;
  margin: 0 auto;
  //background-color: #fff;

  .logo {
    width: 400px;
    padding: 10px;

    img {
      width: 100%;
      line-height: 60px;
    }
  }
}

.el-main {
  padding: 0 !important;
}

.footer {
  width: 100%;
  height: 216px;
  overflow: hidden;
  background-color: #14679f;

  &-content {
    margin-top: 10px;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center; /* 确保内容垂直居中 */

    .content-nav {
      margin-left: 20%; /* 左侧留出空间 */
      display: flex;
      justify-content: space-around;

      li {
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        align-items: flex-start;

        p {
          font-size: 20px;
          color: #d4edff;
          padding: 10px 0;
        }

        span {
          color: #f7f7f7;
          font-weight: 300;
          padding: 5px 0;
        }
      }
    }

    .qr-code-container {
      display: flex; /* 使用 Flexbox 布局 */
      align-items: center; /* 垂直居中 */
      margin-right: 20%; /* 右侧留出空间 */

      div {
        display: flex;
        flex-direction: column; /* 将二维码和说明文字垂直排列 */
        align-items: center; /* 内容居中 */
        margin-left: 20px; /* 两个二维码之间的间距 */

        img {
          width: 100px; /* 调整二维码宽度 */
          height: 100px; /* 调整二维码高度 */
        }

        span {
          margin-top: 10px; /* 二维码和说明文字之间的间距 */
          color: #f7f7f7; /* 说明文字颜色 */
          font-size: 14px; /* 说明文字大小 */
        }
      }
    }
  }

  .copyright {
    height: 30px;
    background: #125688;
    display: flex;
    justify-content: center; /* 版权信息居中 */
    align-items: center;

    span {
      color: #fff;
      line-height: 30px;
    }
  }
}
</style>
